<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0_451_24201)">
			<path
				d="M20.4947 20.044C20.7492 20.1134 21 19.9218 21 19.6581V8.21463C21 8.03422 20.8792 7.87613 20.7051 7.8287L19.8688 7.60079C19.6143 7.53146 19.3636 7.72301 19.3636 7.98672V15.2727C19.3636 15.6122 19.1509 15.919 18.8318 16.0377L14.5084 17.6606C14.145 17.797 14.1693 18.3189 14.5437 18.421L20.4947 20.044Z"
				:fill="props.iconColor"
			/>
			<path
				d="M5.16818 16.0377C4.84909 15.919 4.63636 15.6122 4.63636 15.2727V7.98672C4.63636 7.72301 4.38563 7.53146 4.1312 7.60079L3.29483 7.8287C3.12077 7.87613 3 8.03422 3 8.21463V19.6581C3 19.9218 3.25079 20.1134 3.50525 20.044L9.45628 18.421C9.8307 18.3189 9.85494 17.797 9.4916 17.6606L5.16818 16.0377Z"
				:fill="props.iconColor"
			/>
			<path
				d="M18.2857 15.37C18.4419 15.3115 18.5454 15.1622 18.5454 14.9954V7.23818V6.82909V6.42V3.57702C18.5454 3.29779 18.2666 3.10448 18.0051 3.20245L12.6687 5.2018C12.5125 5.26032 12.4091 5.4096 12.4091 5.57638V16.7005V17.0318V17.1382V17.2003C12.4091 17.3799 12.5886 17.5042 12.7568 17.4409L18.2857 15.37Z"
				:fill="props.iconColor"
			/>
			<path
				d="M11.2432 17.4409C11.4106 17.5059 11.591 17.3824 11.591 17.2029V17.1382V17.0318V16.7005V5.5803C11.591 5.4136 11.4876 5.26438 11.3315 5.2058L5.99515 3.20289C5.73363 3.10473 5.45459 3.29805 5.45459 3.57738V6.42V6.82909V7.23818V14.9954C5.45459 15.1622 5.55809 15.3115 5.71429 15.37L11.2432 17.4409Z"
				:fill="props.iconColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_451_24201">
				<rect width="18" height="17.1818" :fill="props.iconColor" transform="translate(3 3)" />
			</clipPath>
		</defs>
	</svg>
</template>

<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 24,
		height: 24,
		iconColor: '#ffffff',
	}
);
</script>

<style lang="scss" scoped></style>
